export function SettingsViewOnlyBanner() {
  return (
    <p className="mb-5 rounded-xl border border-surface-3 bg-surface-2/40 px-4 py-3 text-[12.5px] text-fg-2 leading-relaxed">
      View only on most settings. On General you can still update your user name.
    </p>
  );
}
